import { createComponent } from '@helpers/admin';
import CallRatesSearchSectionComponent from '@template/blocks/CallRatesSearchSection/component';

export const CallRatesSearch = createComponent({
  label: 'Call Rates Search',
  component: CallRatesSearchSectionComponent,
  fields: {},
});
